import { ComponentProps, FC, forwardRef } from 'react'
import { SvgIconComponent } from '@mui/icons-material'
import { useLoadDynamicMuiIcon } from './hooks/useLoadDynamicMuiIcon'
import SvgIcon from '@mui/material/SvgIcon'

export interface DynamicIconProps extends ComponentProps<typeof SvgIcon> {
  icon: string
  fallback?: SvgIconComponent
}

export const DynamicMuiIcon: FC<DynamicIconProps> = forwardRef(function DynamicIcon(
  { icon, fallback: Fallback, ...rest },
  ref
) {
  const { SvgElement, isLoading, error } = useLoadDynamicMuiIcon(icon)

  if (error) return Fallback ? <Fallback ref={ref} {...rest} /> : null
  if (isLoading) return null
  if (!SvgElement) return null

  return <SvgElement ref={ref} {...rest} />
})
